<template>
    <div>
        <!-- 标题-->
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item :to="{ name: 'ActivityManager' }">活动管理</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
        </el-breadcrumb>
        <!--选项卡-->
        <el-tabs type="border-card" v-model="actFlag">
            <el-tab-pane label="活动基础信息" name="first" :disabled="one">
                <ActBase v-on:listenToChildEvent="showMsgFromChild"
                         :actID="actId"
                         :status="status_btn"
                         :act_status="actStatus">
                </ActBase>
            </el-tab-pane>
            <el-tab-pane label="选择参与条件" name="second" :disabled="two">
                <CheckCondition v-on:listenToChildEvent="showMsgFromChild"
                                :actID="actId" :status="status_btn"></CheckCondition>
            </el-tab-pane>
            <el-tab-pane label="选择售货机" name="third" :disabled="three">
                <ChoiceDevice v-on:listenToChildEvent="showMsgFromChild"
                              :actID="actId" :status="status_btn"></ChoiceDevice>
            </el-tab-pane>
            <el-tab-pane label="选择应用" name="fourth" :disabled="four">
                <ChoiceApp v-on:listenToChildEvent="showMsgFromChild"
                           :actID="actId" :status="status_btn" :act_status="actStatus"></ChoiceApp>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import ActBase from "~/components/views/activity/ActBase";
    import ChoiceApp from "~/components/views/activity/ChoiceApp";
    import CheckCondition from "~/components/views/activity/ChoiceCondition";
    import ChoiceDevice from "~/components/views/activity/ChoiceDevice";
    import EchartsTest from "~/components/views/activity/EchartsTest";

    export default {
        name: "CreateActivity",
        components: {EchartsTest, ChoiceDevice, CheckCondition, ChoiceApp, ActBase},
        data() {
            return {
                actFlag: 'first',
                actId:" ",
                isEditer:false,
                status_btn:'',//按钮状态
                title:"创建活动",
                one:false,
                two:true,
                three:true,
                four:true,
                actStatus:'',//活动状态
            }
        },
        created(){
            this.actId=this.$route.query.actId;
            // this.isEditer=this.$route.query.isEditer;
            this.status_btn=this.$route.query.btnStatus;
            this.actStatus=this.$route.query.act_status;
            if (this.status_btn == "0") {
                this.title = "创建活动";
            }else if (this.status_btn == "1") {
                this.title = "编辑活动";
                this.one = false
                this.two = false
                this.three = false
                this.four = false
            }else if (this.status_btn == "2") {
                this.title = "查看活动";
                this.one = false
                this.two = false
                this.three = false
                this.four = false
            }
        },
        methods: {
            showMsgFromChild:function (flag,actId) {
                this.actId = actId;
                console.log("活动ID："+actId+"--"+this.actId)
                if (flag == "1") {
                    this.actFlag = "first";
                    this.one = false
                    this.two = true
                    this.three = true
                    this.four = true
                }
                if (flag == "2") {
                    this.actFlag = "second";
                    this.one = false
                    this.two = false
                    this.three = true
                    this.four = true
                }
                if (flag == "3") {
                    this.actFlag = "third";
                    this.one = false
                    this.two = false
                    this.three = false
                    this.four = true
                }
                if (flag == "4") {
                    this.actFlag = "fourth";
                    this.one = false
                    this.two = false
                    this.three = false
                    this.four = true
                }
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreateActivity.vue?7eb190c1